// extracted by mini-css-extract-plugin
export default {"infoPrivacyPolicy":"PrivacyPolicyAgreementEntry-module__infoPrivacyPolicy___G9mFy"};